import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'paybylink_content_validation';
export const route = 'paybylink/membership_retention/[payByLinkContentId]/[scenarioId]';
export const PayByLinkContentValidationPage = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "paybylink_content_validation" */
/* webpackPrefetch: true */
'../../components/Prime/PayByLink/PayByLinkContentValidationPage')));